"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;

var validate = function validate(_ref) {
  var streamers = _ref.streamers,
      liveInfo = _ref.liveInfo,
      onClick = _ref.onClick;

  if (!(streamers !== null && streamers !== void 0 && streamers.length)) {
    throw new Error("[DomestikaPastLiveCard.validate] streamers(".concat(streamers, ")"));
  }

  streamers.forEach(function (_ref2, index) {
    var name = _ref2.name;

    if (!name) {
      throw new Error("[DomestikaPastLiveCard.validate] streamers[".concat(index, "].name(").concat(name, ")"));
    }
  });

  if (!liveInfo) {
    throw new Error("[DomestikaPastLiveCard.validate] liveInfo(".concat(liveInfo, ")"));
  }

  var scheduledAt = liveInfo.scheduledAt,
      language = liveInfo.language,
      title = liveInfo.title;

  if (!scheduledAt) {
    throw new Error("[DomestikaPastLiveCard.validate] scheduledAt(".concat(scheduledAt, ")"));
  }

  if (!language) {
    throw new Error("[DomestikaPastLiveCard.validate] language(".concat(language, ")"));
  }

  if (!title) {
    throw new Error("[DomestikaPastLiveCard.validate] title(".concat(title, ")"));
  }

  if (typeof onClick !== 'function') {
    throw new Error("[DomestikaPastLiveCard.validate] onClick(".concat(onClick, ")"));
  }
};

exports.validate = validate;